module.exports = __webpack_public_path__ + "media/images/external-link-alt-solid-654c5f63123e657f77702b65807a5021.svg";